export namespace TechnologyPlatformConstants {
  export const UZURV_WAV_CODE = 'UZURV_WAV';
  export const MEDIROUTES_CODE = 'MEDIROUTES';
  export const ZTRIP_CODE = 'ZTRIP';
  export const NONE_CODE = 'NONE';
  export const ROUTEGENIE_CODE = 'ROUTEGENIE';
  export const UZURV_CODE = 'UZURV';
  export const LYFT_CODE = 'LYFT';
}
